import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import AnalystDashboard from "./AnalystDashboard";
import AssignedClients from "./AssignedClients";
import DataTables from "./DataTables";
import DesignReport from "./DesignReport";
import AnalystChat from "./AnalystChat";
import AnalystReports from "./AnalystReports";
import AnalysisDashboard from "./AnalysisDashboard";
import AnalysisWizard from "./AnalysisWizard";
import AnalysisResultView from "./AnalysisResultView";
import Predictions from "./Predictions";
import OrganisationIntelligence from "./OrganisationIntelligence";
import {
  FiBarChart2,
  FiUsers,
  FiActivity,
  FiTable,
  FiEdit3,
  FiMessageSquare,
  FiFileText,
  FiUser,
  FiTrendingUp,
  FiLayers,
} from "react-icons/fi";
import Profile from "../Profile";
import { useTranslation } from "react-i18next";

const ANALYST_LINKS = (t) => [
  { path: "", label: t("nav.dashboard"), icon: FiBarChart2 },
  { path: "/clients", label: t("analyst.assignedClients", "Assigned Clients"), icon: FiUsers },
  { path: "/analysis", label: t("analyst.analysisModels", "Analysis & Models"), icon: FiActivity },
  { path: "/predictions", label: t("analyst.predictions", "Predictions"), icon: FiTrendingUp },
  {
    path: "/organisation-intelligence",
    label: t("analyst.organisationIntelligence", "Organisation Intelligence"),
    icon: FiLayers,
  },
  { path: "/data-tables", label: t("data.table"), icon: FiTable },
  { path: "/reports", label: t("nav.reports"), icon: FiFileText },
  { path: "/design-report", label: t("analyst.designReport", "Design Report"), icon: FiEdit3 },
  { path: "/chat", label: t("nav.chat"), icon: FiMessageSquare },
  { path: "/profile", label: t("profile.profile"), icon: FiUser },
];

function AnalystPortal() {
  const { t } = useTranslation();
  return (
    <div className="portal-layout">
      <Sidebar links={ANALYST_LINKS(t)} basePath="/analyst" />
      <div className="portal-main">
        <Routes>
          <Route
            index
            element={
              <>
                <Header title={t("analyst.dashboardTitle", "Analyst Dashboard")} />
                <AnalystDashboard />
              </>
            }
          />
          <Route
            path="clients"
            element={
              <>
                <Header title={t("analyst.assignedClients", "Assigned Clients")} />
                <AssignedClients />
              </>
            }
          />
          <Route
            path="analysis"
            element={
              <>
                <Header title={t("analyst.analysisModels", "Analysis & Models")} />
                <AnalysisDashboard />
              </>
            }
          />
          <Route
            path="analysis/new"
            element={
              <>
                <Header title={t("analyst.createAnalysis", "Create Analysis")} />
                <AnalysisWizard />
              </>
            }
          />
          <Route
            path="analysis/:analysisId"
            element={
              <>
                <Header title={t("analyst.analysisResults", "Analysis Results")} />
                <AnalysisResultView />
              </>
            }
          />
          <Route
            path="predictions"
            element={
              <>
                <Header title={t("analyst.predictions", "Predictions")} />
                <Predictions />
              </>
            }
          />
          <Route
            path="organisation-intelligence"
            element={
              <>
                <Header
                  title={t(
                    "analyst.organisationIntelligence",
                    "Organisation Intelligence",
                  )}
                />
                <OrganisationIntelligence />
              </>
            }
          />
          <Route
            path="data-tables"
            element={
              <>
                <Header title={t("data.table")} />
                <DataTables />
              </>
            }
          />
          <Route
            path="design-report"
            element={
              <>
                <Header title={t("analyst.designReport", "Design Report")} />
                <DesignReport />
              </>
            }
          />
          <Route
            path="reports"
            element={
              <>
                <Header title={t("nav.reports")} />
                <AnalystReports />
              </>
            }
          />
          <Route
            path="chat"
            element={
              <>
                <Header title={t("nav.chat")} />
                <AnalystChat />
              </>
            }
          />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/analyst" />} />
        </Routes>
      </div>
    </div>
  );
}

export default AnalystPortal;
